"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomThemedResource = void 0;
var react_1 = __importDefault(require("react"));
var cdn_1 = require("../utils/cdn");
var CustomThemedResource = function (props) {
    var className = props.className, source = props.source, alt = props.alt, format = props.format;
    var extension = format !== null && format !== void 0 ? format : "webp";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("img", { "data-hide-on-theme": "dark", src: (0, cdn_1.assetUrl)(source + "-light." + extension + "?aaa"), className: className, alt: alt }),
        react_1.default.createElement("img", { "data-hide-on-theme": "light", src: (0, cdn_1.assetUrl)(source + "-dark." + extension + "?aaa"), className: className, alt: alt })));
};
exports.CustomThemedResource = CustomThemedResource;
//# sourceMappingURL=image.js.map